"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTypeCode = exports.WorkingData = void 0;
var WorkingData;
(function (WorkingData) {
    /**
     * When this option is used, if a task returns an object/record with multiple attribs, then each attrib is saved in a separate DataRef
     *  (eg, each as an item in a redis hset.) This granularity is conveyor-friendly, permitting a subsequent task to modify or load a single attrib.
     */
    WorkingData["ExpandRecordsByAttrib"] = "ExpandRecordsByAttrib";
    /**
     * When this option is used, an object/record with multiple attribs will be stored as a single (serialized) item.
     * (If on a redis hash, then with a special reserved attrib "_$w_solo".)
     * todo: try using outputAsNamedAttrib?
     */
    WorkingData["ForceToSoloItem"] = "ForceToSoloItem";
    // /**
    //  * Uses author attrib name, or default, as set on task element. Wraps the output value in that attrib unless it's already been done,
    //  *  the only item in the record.
    //  */
    // NamedRecordAttribUnlessPresent = 'NamedRecordAttribUnlessPresent',
    /**
     * When set on a task, its output is passed directly to kahba control script without being saved as working data.
     *
     * For example, a switch router workflow needs to know which step/branch to call based on the result of some conditional/predicate
     *  step. By setting that step with this ResultAsAuxControlData flag, the data is passed to the kahba script, which otherwise
     *  sees only dataRefs.
     * (Data size limits apply.)
     */
    WorkingData["ResultAsAuxControlData"] = "ResultAsAuxControlData";
})(WorkingData = exports.WorkingData || (exports.WorkingData = {}));
var DataTypeCode;
(function (DataTypeCode) {
    // These are straightforward ones, where "typeof" works. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof#description
    DataTypeCode["BigInt"] = "bigint";
    DataTypeCode["Boolean"] = "boolean";
    DataTypeCode["Function"] = "function";
    DataTypeCode["Number"] = "number";
    DataTypeCode["String"] = "string";
    DataTypeCode["Symbol"] = "symbol";
    DataTypeCode["Undefined"] = "undefined";
    // These are the tricky (non-binary) troubled-js "object" types I can think of:
    DataTypeCode["Array"] = "array";
    DataTypeCode["Date"] = "Date";
    DataTypeCode["Map"] = "mapObj";
    DataTypeCode["Null"] = "null";
    DataTypeCode["Record"] = "record";
    DataTypeCode["RegExp"] = "regex";
    DataTypeCode["Set"] = "setArr";
    DataTypeCode["WeakMap"] = "weakMap";
    DataTypeCode["WeakSet"] = "weakSet";
    DataTypeCode["JsError"] = "jsErr";
    DataTypeCode["BinaryProb"] = "binProb";
    DataTypeCode["PlusPlusPlus"] = "PlusPlusPlus";
    DataTypeCode["Unknown"] = "unknown";
    // also NaN, Infinite? others?
})(DataTypeCode = exports.DataTypeCode || (exports.DataTypeCode = {}));
//# sourceMappingURL=working-data.js.map